import { ArrowTopRightOnSquareIcon } from '@interstate/components/Icons';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as creditAppSelectors from '@makemydeal/dr-dash-store/selectors/creditAppSelectors';
import * as creditDecisionSelectors from '@makemydeal/dr-dash-store/selectors/creditDecisionSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useSelector } from 'react-redux';
import CreditDecisionTerms from './CreditDecisionTerms';
import {
    CardContainer,
    DealertrackContainer,
    DeepLinkDealertrack,
    DescriptionInfo,
    FinancingContainer,
    FinancingTitle,
    LayoutContainer,
    LenderDecisionContainer,
    LenderInfoContainer,
    SendLinkContainer,
    SendLinkWrapper
} from './LenderDecisionInfo.style';
import { LenderList } from './LenderList';

const LenderDecisionInfo = () => {
    const creditProviderIsRouteOne = useSelector(dealerSelectors.isCreditProviderRouteOne);
    const isRouteOneCreditBureauHidden = useSelector(featureToggleSelectors.enableHideRouteOneCreditBureau);
    const updateCreditProviderDeeplink = creditProviderIsRouteOne && isRouteOneCreditBureauHidden;
    const dealRefId = useSelector(offerSelectors.getDealRefId);
    const isCreditAppCompleted = useSelector(creditAppSelectors.isCreditAppCompleted);
    const submittedOn = useSelector(creditAppSelectors.getCreditAppSubmittedOn);
    const configUrl = useSelector(configSelectors.getDealertrackUrl);
    const lenderDecisions = useSelector(creditDecisionSelectors.getLenderCreditDecisions);
    const numberLenderDecisions = lenderDecisions.length;
    const isDealXgRecordMissed = useSelector(offerReduxSelectors.getIsDealXgRecordMissed);
    const hasCustomer = Boolean(useSelector(offerSelectors.getOfferCommonConsumerId));
    // TODO: add parseTimeStampToMMDDYYYY to dr-common-utils later
    const parseTimeStampToMMDDYYYY = (timeStamp: number) => {
        const dateFormat = new Date(timeStamp * 1000);
        const dateStringFormat = `${dateFormat.getMonth() + 1}/${dateFormat.getDate()}/${dateFormat.getFullYear()}`;
        return dateStringFormat;
    };

    const timeStampFormatter = submittedOn !== 0 ? parseTimeStampToMMDDYYYY(submittedOn) : submittedOn;

    const getDealerTrackDeepLink = () => {
        let url: string;
        if (updateCreditProviderDeeplink) {
            url = 'https://www.routeone.net/';
        } else {
            url = `${configUrl}/view_application/FD/${dealRefId}/`;
        }
        return url;
    };

    return (
        <LenderDecisionContainer data-testid="lender-decision-layout">
            <DescriptionInfo>
                <FinancingContainer>
                    <FinancingTitle>Financing Terms</FinancingTitle>
                    <DealertrackContainer>
                        <DeepLinkDealertrack
                            href={getDealerTrackDeepLink()}
                            target="_blank"
                            data-testid="dealerTrack-link"
                            style={
                                isDealXgRecordMissed || !hasCustomer
                                    ? {
                                          pointerEvents: 'none',
                                          opacity: 0.5,
                                          cursor: 'not-allowed',
                                          color: '#666666',
                                          textDecoration: 'none'
                                      }
                                    : undefined
                            }
                        >
                            <div>
                                <ArrowTopRightOnSquareIcon />
                            </div>
                            {updateCreditProviderDeeplink ? <span>Open RouteOne</span> : <span>Open Dealertrack</span>}
                        </DeepLinkDealertrack>
                    </DealertrackContainer>
                </FinancingContainer>
                <SendLinkContainer data-testid="send-link-container">
                    <SendLinkWrapper>
                        <a>Send Link</a>
                    </SendLinkWrapper>
                    {isCreditAppCompleted && timeStampFormatter ? (
                        <span>Credit Application Completed - {timeStampFormatter}</span>
                    ) : (
                        <span>Credit Application Not Submitted</span>
                    )}
                </SendLinkContainer>
            </DescriptionInfo>

            <LayoutContainer>
                <CardContainer>
                    <span className="lenderDecisionTitle">Lender Decisions ({numberLenderDecisions})</span>
                    <LenderList lenderDecisions={lenderDecisions} sortOrder={['approvalStatus']} />
                </CardContainer>
                <LenderInfoContainer>
                    <CreditDecisionTerms />
                </LenderInfoContainer>
            </LayoutContainer>
        </LenderDecisionContainer>
    );
};

export default LenderDecisionInfo;
